import { useMemo } from 'react';
import { GetFlag } from '../../utils/featureFlag';
import { commerceApi, customersAuthorizationApi } from '../api';

// GR-444
// Uso do token do ADOBE condicionado a feature flag
export const useApiInstance = () => {
  const isFlagActive = GetFlag('commerce-token-validation');

  const apiInstance = useMemo(() => {
    if (isFlagActive) {
      return commerceApi;
    }

    return customersAuthorizationApi;
  }, [isFlagActive]);

  return apiInstance;
};
